import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from 'store/index';
import { Categories } from 'store/slices/cars/types';
import type { SubscriptionPackage } from './subscriptions.slice';

const SubscriptionsSelector = (state: RootState) => state.subscriptions;
export const selectAllSubscriptions = createSelector(
  SubscriptionsSelector,
  (state) => state.items,
);

export const selectSubscriptionPendingStatus = createSelector(
  SubscriptionsSelector,
  (state) => state.isPending,
);

export const selectSubscriptionPackages = createSelector(
  SubscriptionsSelector,
  (state) => {
    const order = {
      '15_DAYS': 0,
      '30_DAYS': 1,
      '45_DAYS': 2,
    };

    const result: Record<Categories, Array<SubscriptionPackage>> = {
      [Categories.ELEGANT]: [],
      [Categories.SPORT]: [],
      [Categories.SUPER_SPORT]: [],
      [Categories.EXCLUSIVE]: [],
    };
    for (const key in state.subscriptionPackages) {
      result[key as Categories] = [
        ...state.subscriptionPackages[key as Categories],
      ].sort((a, b) => order[a.type] - order[b.type]);
    }

    return result;
  },
);

export const selectSubscriptionPackagesPendingStatus = createSelector(
  SubscriptionsSelector,
  (state) => state.subscriptionPackagesIsPending,
);

export const selectSelectedPackage = createSelector(
  SubscriptionsSelector,
  (state) => state.selectedPackage,
);

export const selectIsSubscriptionCreationInProgress = createSelector(
  SubscriptionsSelector,
  (state) => state.isCreationInProgress,
);

export const selectCachedSubscriptions = createSelector(
  SubscriptionsSelector,
  (state) => state.cachedSelectedSubscriptions,
);
